import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from 'react-datepicker'
import { Link } from "react-router-dom";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';
import 'react-datepicker/dist/react-datepicker.css'
import es from "date-fns/locale/es";

registerLocale('es', es);

const Trips = () => {
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(new Date());
    const [date_max, setDateMax] = useState(new Date);
    const [trip_id, setTripId] = useState(0);
    const [trips, setTrips] = useState([]);
    const [driver_id, setDriverId] = useState(0);
    const [drivers, setDrivers] = useState([]);
    const [letter_id, setLetterId] = useState(0);
    const [letters, setLetters] = useState([]);
    const [unit_id, setUnitId] = useState(0);
    const [units, setUnits] = useState([]);
    const [active, setActive] = useState(0);
    const [inactive, setInactive] = useState(0);
    const [status_filter, setStatusFilter] = useState(2);
    const [unit_filter, setUnitFilter] = useState(0);
    const [role_id, setRoleId] = useState(0);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;


    useEffect(() => {
        getAll();
        getUnits();
        getDrivers();
        getLetters();
        const date = new Date();
        date.setDate(date.getDate() + 7);
        setDateMax(date);
        setTimeout(() => {
            $('.select2').select2({ width: "100%", placeholder: "Seleccione", dropdownParent: $('#modal-default') });
            $('#status_filter').select2({ width: "100%", placeholder: "Seleccione", dropdownParent: $('.card-body') });
        }, 100);
        // Initialize tooltips
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
        const user = JSON.parse(localStorage.getItem('dataUser'));
        setRoleId(user.rol_id);
    }, []);

    const selectStatus = [
        { label: 'Todos', value: 2 },
        { label: 'Activo', value: 1 },
        { label: 'Cancelado', value: 0 }
    ];

    $('#status_filter').on("change", function (e) {
        setStatusFilter(e.target.value);
    });

    $('#unit_filter').on("change", function (e) {
        setUnitFilter(e.target.value);
    });

    $('#unit_id').on("change", function (e) {
        setUnitId(e.target.value);
    });

    $('#letter_id').on("change", function (e) {
        setLetterId(e.target.value);
    });

    $('#driver_id').on("change", function (e) {
        setDriverId(e.target.value);
    });

    const isGreaterDateTime = (dateCompare, timeCompare) => {
        const now = new Date();
        const date = dateCompare.split('-');
        const year = parseInt(date[0]);
        const month = parseInt(date[1] - 1);
        const day = parseInt(date[2]);
        const time = timeCompare.split(':');
        const hours = parseInt(time[0]);
        const minutes = parseInt(time[1]);
        const specificDate = new Date(year, month, day, hours, minutes, 0);
        if (specificDate > now) {
            return false;
        } else {
            return true;
        }
    }

    const getUnits = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-units-trips');
        const unitsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.unit_id,
            };
        })
        setUnits(unitsArray);
    };

    const getDrivers = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-drivers-trips');
        const driversArray = response.data.data.map(function (element) {
            return {
                label: element.name + ' ' + element.last_name,
                value: element.driver_id,
            };
        })
        setDrivers(driversArray);
    };

    const getLetters = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-letters-trips');
        const lettersArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.letter_id,
            };
        })
        setLetters(lettersArray);
    };

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [useDateRange, setUseDateRange] = useState(false);

    const getAll = async () => {
        setLoading(true);
    const form = new FormData();
    form.append('status_filter', status_filter);
    form.append('unit_filter', unit_filter);
    
    if (useDateRange) {
        const start = startDate.toISOString().split('T')[0];
        const end = endDate.toISOString().split('T')[0];
        form.append('start_date', start);
        form.append('end_date', end);
    } else {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        form.append('date', year + '-' + month + '-' + day);
    }
    
    await axios.post(ENDPOINT + 'get-trips-day', form)
            .then(response => {
                setActive(response.data.data.filter(e => e.status === 1).length);
                setInactive(response.data.data.filter(e => e.status === 0).length);
                setTrips(response.data.data);
                var table = $('.main').DataTable();
                table.destroy();
                setTimeout(() => {
                    $('.main').DataTable({
                        searching: true,
                        destroy: true,
                        retrieve: true,
                        pageLength: 50,
                        responsive: false,
                        autoWidth: true,
                        paging: true,
                        ordering: true,
                        sortable: true,
                        processing: false,
                        serverSide: false,
                        bInfo: true,
                        language: {
                            "decimal": "",
                            "emptyTable": "",
                            "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                            "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                            "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                            "infoPostFix": "",
                            "thousands": ",",
                            "lengthMenu": "Mostrar _MENU_ registros",
                            "loadingRecords": "Cargando...",
                            "processing": "Procesando...",
                            "search": "Buscar:",
                            "paginate": {
                                "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                                "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                                "next": "<i class='fas fa-arrow-circle-right'></i>",
                                "previous": "<i class='fas fa-arrow-circle-left'></i>"
                            },
                            "zeroRecords": "No hay registros",
                            "searchPlaceholder": "Buscar por sucursal",
                        },
                    });
                    setLoading(false);
                }, 100);
            }).catch(function (error) {
                setLoading(false);
                console.log(error)
            });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await axios
            .put(ENDPOINT + "update-trip/" + trip_id, {
                unit_id: unit_id,
                letter_id: letter_id,
                driver_id: driver_id
            })
            .then((response) => {
                getAll();
                clearField();
                setLoading(false);
                $("#closemodal").trigger("click");
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(true);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const toggleSwitch = async (val) => {
        setLoading(true);
        await axios.get(ENDPOINT + 'get-trip-status/' + val)
            .then(response => {
                getAll();
                setLoading(false);
                Swal.fire({
                    icon: 'success',
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                    showClass: { popup: 'animate__animated animate__fadeInDown' },
                    hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                })
            }).catch(function (error) {
                console.log(error)
                setLoading(false);
                Swal.fire({
                    icon: 'error',
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                    showClass: { popup: 'animate__animated animate__fadeInDown' },
                    hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                })
            });
    };

    const handleEdit = async (id) => {
        setLoading(true);
        await axios.get(ENDPOINT + 'get-trip/' + id)
            .then(response => {
                setLoading(false);
                setTitle('Editar Viaje');
                setTripId(response.data.data.trip_id);
                setDriverId(response.data.data.driver_id);
                setLetterId(response.data.data.letter_id);
                setUnitId(response.data.data.unit_id);
                $('#driver_id').removeClass('select2');
                $('#letter_id').removeClass('select2');
                $('#unit_id').removeClass('select2');
                setTimeout(() => {
                    $('#driver_id').addClass('select2');
                    $('#letter_id').addClass('select2');
                    $('#unit_id').addClass('select2');
                    $('.select2').select2({ width: "100%", dropdownParent: $('#modal-default') });
                }, 100);
            }).catch(function (error) {
                console.log(error)
                setLoading(false);
            });
    };

    const handleDelete = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#3085d6",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.delete(ENDPOINT + 'delete-trip/' + id)
                    .then(response => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: 'success',
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                            showClass: { popup: 'animate__animated animate__fadeInDown' },
                            hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                        })
                    }).catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: 'error',
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                            showClass: { popup: 'animate__animated animate__fadeInDown' },
                            hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                        })
                    });
            }
        });
    };

    const clearField = () => {
        setTripId(0);
        setUnitId(0);
        setLetterId(0);
        setDriverId(0);
    };

    const resetPage = () => {
        window.location.reload();
    };

    const handlePrint = async () => {
        setLoading(true);
        const form = new FormData();
        form.append('status_filter', status_filter);
        form.append('unit_filter', unit_filter);
        
        if (useDateRange) {
            const start = startDate.toISOString().split('T')[0];
            const end = endDate.toISOString().split('T')[0];
            form.append('start_date', start);
            form.append('end_date', end);
        } else {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            form.append('date', year + '-' + month + '-' + day);
        }
        
        await axios.post(ENDPOINT + 'print-pdf-trips', form, { responseType: "blob" })
            .then((response) => {
                const url = window.URL.createObjectURL(response.data);
                window.open(url, '_blank');
                setLoading(false);
            }).catch(function (error) {
                setLoading(false);
                Swal.fire({
                    icon: 'error',
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    html: '<div class="text-custom-alert">No hay datos para generar el reporte</div>',
                    showClass: { popup: 'animate__animated animate__fadeInDown' },
                    hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                })
            });

    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatTime = (timeString) => {
        if (!timeString) return "";
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
        const hours12 = (date.getHours() % 12) || 12;
        const formattedHours12 = hours12.toString().padStart(2, '0');
        return `${formattedHours12}:${formattedMinutes} ${ampm}`;
    };

    return (
        <>
            {loading && <Loader />}
            <div className="modal fade" id="modal-default" aria-labelledby="modal-default" data-bs-backdrop="static" data-bs-keyboard="false"  aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">{title}</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="trip-form-header">
                                    <h3 className="trip-form-title">Modificar Viaje</h3>
                                    <p className="trip-form-subtitle">Complete los datos necesarios para actualizar el viaje</p>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="unit_id" className="col-form-label col-form-label-sm">
                                                Unidad <span className="trip-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="unit_id"
                                                name="unit_id"
                                                required
                                            >
                                                {units.map((item, index) => (
                                                    <option
                                                        selected={item.value === unit_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="trip-field-hint">Seleccione el vehículo asignado para este viaje</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="driver_id" className="col-form-label col-form-label-sm">
                                                Conductor <span className="trip-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="driver_id"
                                                name="driver_id"
                                                required
                                            >
                                                {drivers.map((item, index) => (
                                                    <option
                                                        selected={item.value === driver_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="trip-field-hint">Seleccione el conductor asignado para el viaje</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="letter_id" className="col-form-label col-form-label-sm">
                                                Letra <span className="trip-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="letter_id"
                                                name="letter_id"
                                                required
                                            >
                                                {letters.map((item, index) => (
                                                    <option
                                                        selected={item.value === letter_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="trip-field-hint">Seleccione la letra asignada al viaje</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    Actualizar
                                </button>
                                <button
                                    id="closemodal"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban me-1"></i>
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <ContentHeader
                    title="Módulo de Viajes"
                />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-map	me-2"></i> Listado de Viajes
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <Link
                                    to="/agregar-viajes"
                                    className="btn btn-success btn-sm me-1"
                                    data-toggle2="tooltip"
                                    data-placement="left"
                                    title="Añadir sucursal">
                                    <i className="fas fa-plus-circle me-1"></i> Agregar
                                </Link>
                                
                                <Link
    to="/rol-trabajo"
    className="btn btn-warning btn-sm me-1"
    data-toggle2="tooltip"
    data-placement="left"
    title="Generar rol del día siguiente">
    <i className="fas fa-calendar-day me-1"></i> Generar Rol Día Siguiente
</Link>

                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="indications row mb-4">
                            <div className="col-md-3 col-sm-6 mb-2">
                                <div className="form-group trip-filter-group">
                                    <label htmlFor="select_status" className="col-form-label col-form-label-sm">
                                        Estado
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="status_filter"
                                        name="status_filter"
                                    >
                                        {selectStatus.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="trip-field-hint">Filtrar viajes por estado</small>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
    <div className="form-group trip-filter-group">
        <label className="col-form-label col-form-label-sm">
            {useDateRange ? 'Rango de fechas' : 'Fecha'}
        </label>
        <div className="form-check form-switch mb-2">
            <input
                className="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
                checked={useDateRange}
                onChange={() => setUseDateRange(!useDateRange)}
            />
            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                Usar rango
            </label>
        </div>
        
        {useDateRange ? (
            <>
                <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    className="form-control form-control-sm mb-1"
                    dateFormat="dd/MM/yyyy"
                    locale="es"
                />
                <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    className="form-control form-control-sm"
                    dateFormat="dd/MM/yyyy"
                    locale="es"
                />
            </>
        ) : (
            <DatePicker
                showIcon
                locale="es"
                selected={date}
                onChange={(date) => setDate(date)}
                className="form-control form-control-sm w-100"
                required
                dateFormat="dd, MMMM, yyyy"
            />
        )}
        <small className="trip-field-hint">
            {useDateRange ? 'Seleccione el rango de fechas' : 'Seleccione una fecha específica'}
        </small>
    </div>
</div>
                            <div className="col-md-4 col-sm-6 mb-3" style={{ display: "flex", justifyContent: 'start', alignItems: "center" }}>
                                <button
                                    onClick={() => getAll()}
                                    className="btn btn-primary btn-sm me-1"
                                    type="button" >
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                                <button
                                    onClick={() => handlePrint()}
                                    className="btn btn-danger btn-sm me-1">
                                    <i className="fa-solid fa-file-pdf me-1"></i> Descargar
                                </button>
                            </div>
                            <div className="col-xs-3 col-md-3">
                                <div className="form-group">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="text-center">
                                                <td className="indications-table" width="30%" >Total</td>
                                                <td className="indications-table" width="30%" >Activos</td>
                                                <td className="indications-table" width="30%" >Cancelados</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td id="TuserT">{active + inactive}</td>
                                                <td id="TuserA">{active}</td>
                                                <td id="TuserI">{inactive}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <table className="table table-hover main table-striped">
                            <thead>
                                <tr>
                                    <th width="10%" className="text-center">#</th>
                                    <th width="20%" className="text-left">Sucursal</th>
                                    <th width="10%" className="text-center">Fecha</th>
                                    <th width="10%" className="text-center">Horario</th>
                                    <th width="10%" className="text-left">Unidad</th>
                                    <th width="10%" className="text-center">Letra</th>
                                    <th width="10%" className="text-left">Conductor</th>
                                    
                                    <th width="5%" className="text-center">Camino</th>
                                    <th width="10%" className="text-center">Ingreso</th>
                                    <th width="10%" className="text-center">Estado</th>
                                    
                                        <th width="10%" className="text-center">Opciones</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                {trips.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <kbd># {item.trip_id}</kbd>
                                        </td>
                                        <td>
                                            {item.schedule.branch.name}
                                        </td>
                                        <td className="text-center">
                                            {formatDate(item.date)}
                                        </td>
                                        <td className="text-center">
                                            {formatTime(item.schedule.time)}
                                        </td>
                                        <td>
                                            {item.unit.name}
                                        </td>
                                        <td className="text-center">
                                            {item.letter.name}
                                        </td>
                                        <td>
                                            {item.driver.name + ' ' + item.driver.last_name}
                                        </td>
                                        

                                          <td className="text-center">
    {item.has_bill_way ? (
        <span 
            className="text-success"
            data-bs-toggle="tooltip" 
            data-bs-placement="top" 
            title="Tiene ingreso registrado"
        >
            <i className="fa-solid fa-square-check fa-xl" style={{color: '#28a745'}}></i>
        </span>
    ) : (
        <span 
            className="text-danger"
            data-bs-toggle="tooltip" 
            data-bs-placement="top" 
            title="Sin ingreso registrado"
        >
            <i className="fa-solid fa-square-xmark fa-xl" style={{color: '#dc3545'}}></i>
        </span>
    )}
</td>

                                        <td className="text-center">
                                            {item.has_bill_way && item.bill_way_ingreso ? (
                                                <span className="badge bg-success">
                                                    ${item.bill_way_ingreso}
                                                </span>
                                            ) : (
                                                <span className="badge bg-secondary">-</span>
                                            )}
                                        </td>


                                        <td className="text-center">
                                            <div
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                //title={`${isGreaterDateTime(item.date, item.schedule.time) === true ? 'No se puede cambiar el estado de este horario ya se ejecuto' : 'Cambiar el estado'}`}
                                            >
                                                <Switch
                                                    //disabled={isGreaterDateTime(item.date, item.schedule.time)}
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                    checked={item.status === 1 ? true : false}
                                                    onChange={() => toggleSwitch(item.trip_id)}
                                                />
                                            </div>
                                        </td>
                                        
                                        <td className="text-center">
                                             
                                            <div>
                                                <span
                                                    //title={`${isGreaterDateTime(item.date, item.schedule.time) === true ? 'No se puede editar horario ya se ejecuto' : 'Editar registro'}`}
                                                    data-bs-toggle="tooltip"
                                                    data-placement="top">
                                                    <button
                                                        //disabled={isGreaterDateTime(item.date, item.schedule.time)}
                                                        //className={`btn-sm btn me-1 ${isGreaterDateTime(item.date, item.schedule.time) === true ? 'btn-disabled btn-outline-warning' : 'btn-warning'}`}
                                                        className="btn btn-warning btn-sm me-1"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-default"
                                                        onClick={() => handleEdit(item.trip_id)}
                                                    >
                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                    </button>
                                                </span>
                                                { role_id !== 3 &&
                                                <button
                                                    //disabled={isGreaterDateTime(item.date, item.schedule.time)}
                                                    //className={`btn-sm btn me-1 ${isGreaterDateTime(item.date, item.schedule.time) === true ? 'btn-disabled btn-outline-danger' : 'btn-danger'}`}
                                                    className="btn btn-danger btn-sm me-1"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    //title={`${isGreaterDateTime(item.date, item.schedule.time) === true ? 'No se puede eliminar horario ya se ejecuto' : 'Eliminar registro'}`}
                                                    onClick={() => handleDelete(item.trip_id, item.date + ' ' + item.schedule.time)}
                                                >
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </button>
                                            }
                                            </div>
            
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Trips;